// Vendor imports
const { connect } = require('react-redux')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Container imports
const TopCallToActionExplainerApp = require('./explainer-app-dumb')

function mapStateToProps(state) {
  const { browser, deeplinkUrls, nativeEmbedded } = state.env
  let androidHref
  let iosHref
  if (!browser.get('native') && !nativeEmbedded) {
    if (browser.get('android')) {
      androidHref = deeplinkUrls.get('android')
    }
    if (browser.get('ios')) {
      iosHref = deeplinkUrls.get('ios')
    }
  }
  return {
    androidHref,
    iosHref,
    onAndroidHrefClick,
    onIosHrefClick
  }
}

module.exports = connect(
  mapStateToProps
)(
  TopCallToActionExplainerApp
)

function onAndroidHrefClick() {
  businessEvents.trackSegment('app-download', { platform: 'android' })
}

function onIosHrefClick() {
  businessEvents.trackSegment('app-download', { platform: 'ios' })
}
